export default __webpack_public_path__ + "static/media/950.644b163a.gif";